import { render, staticRenderFns } from "./AddNewBrand.vue?vue&type=template&id=360f8620&"
import script from "./AddNewBrand.vue?vue&type=script&lang=js&"
export * from "./AddNewBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports